import React from "react";
import { Icon } from "@iconify/react";
import style from "../../../scss/Tabla.module.scss";
import { ESTADOS_COMPROMISO, estadoCompromiso } from "../../../constants/compromiso";
import { fechaCorta } from "../../../utils/agenda";

// Celda "Compromiso": texto recortado con "..."; al hacer clic se ve completo
export const CompromisoTextoComponent = ({ elector, onVerDetalle }) => {
  if (!elector.compromiso) {
    return <span className={style.sinCompromiso}>{ESTADOS_COMPROMISO.SIN_COMPROMISO.etiqueta}</span>;
  }

  return (
    <>
      <button
        type="button"
        className={style.textoCompromiso}
        onClick={() => onVerDetalle(elector)}
        title="Ver compromiso completo"
      >
        {elector.compromiso}
      </button>
      {/* con fecha, el compromiso también está en la agenda */}
      {elector.compromisoFecha && (
        <span className={style.fechaCompromiso} title="Está en la agenda">
          <Icon icon="mdi:calendar-check-outline" aria-hidden="true" />
          {fechaCorta(elector.compromisoFecha)}
        </span>
      )}
    </>
  );
};

// Celda "Estado": icono cumplido (verde) o por cumplir (gris); al hacer clic cambia el estado.
// Sin onCambiarEstado (usuario sin permiso) el icono solo informa.
export const CompromisoEstadoComponent = ({ elector, onCambiarEstado }) => {
  const estado = estadoCompromiso(elector);

  if (estado === ESTADOS_COMPROMISO.SIN_COMPROMISO) {
    return <span className={style.sinCompromiso} aria-label={estado.etiqueta}>—</span>;
  }

  const cumplido = estado === ESTADOS_COMPROMISO.CUMPLIDO;
  const claseColor = cumplido ? "text-success" : "text-secondary";

  if (!onCambiarEstado) {
    return (
      <span className={`${style.iconoEstado} ${style.iconoSoloLectura} ${claseColor}`} title={estado.etiqueta}>
        <Icon icon={estado.icono} aria-label={estado.etiqueta} />
      </span>
    );
  }

  const accion = cumplido ? "Marcar como por cumplir" : "Marcar como cumplido";

  return (
    <button
      type="button"
      className={`${style.iconoEstado} ${claseColor}`}
      onClick={() => onCambiarEstado(elector, !cumplido)}
      title={`${estado.etiqueta}. ${accion}`}
      aria-label={`${estado.etiqueta}. ${accion}`}
    >
      <Icon icon={estado.icono} aria-hidden="true" />
    </button>
  );
};
